import { IconButton, Menu, MenuItem, Stack } from "@mui/material";
import { Children, useState } from "react";
import { MoreVert } from "@mui/icons-material";

const TableDynamicActions = (props: any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = !!anchorEl;

  function showInlineActions() {
    return (
      <Stack direction={"row"} justifyContent={"space-between"}>
        {props.children}
      </Stack>
    );
  }

  function showHamburgerActions() {
    return (
      <>
        <IconButton
          id={"hamburger-button"}
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          <MoreVert sx={{ color: props.moreColor }} />
        </IconButton>
        <Menu
          id={"hamburger-menu"}
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
        >
          {Children.map(props.children, (it: any) => (
            it !== null && it !== undefined && it !== false && (
              <MenuItem onClick={() => setAnchorEl(null)}>{it}</MenuItem>
            )

          ))}
        </Menu>
      </>
    );
  }

  return (
    <>
      {Children.toArray(props.children).length <= 2

        ? showInlineActions()
        : showHamburgerActions()}
    </>
  );
};

export default TableDynamicActions;
